import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteConferencePayload } from '@app-store/slices/conferences/deleteConference'

interface TaskAction extends Action {
    payload: IDeleteConferencePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.conferences.delete

function* deleteConferenceSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/event/conference/${payload.conferenceId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Conference deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteConferenceSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteConferenceSagaTask)
}

export default deleteConferenceSaga
